import * as ww from '@wecom/jssdk'

// 微信浏览器
export const isWx = () => {
    const userAgent = navigator.userAgent.toLowerCase()
    return userAgent.indexOf('micromessenger') !== -1
}

// 关闭微信
export const closeWX = () => {
    if (isWx()) {
        ww.closeWindow()
    }
}


// WEBPACK FOOTER //
// ./src/utils/index.js